module.exports = __webpack_public_path__ + "assets/2f5c6758194d28e097922799ee99d565-Home_BG.jpg";